import { memo } from 'react';
import { useReduxState } from 'hooks';
import { Button } from 'components/common';
import { DateRangeSelector } from 'components/common/charts';
import { useEditorDispatch } from 'components/editor';

type DateRangeChange = { fromDate: string; toDate: string };

interface Props {
  onDateRangeChange: (data: DateRangeChange) => void;
  title: string;
}

const EditorVersionHistoryFilters = ({ onDateRangeChange, title }: Props) => {
  const editorDispatch = useEditorDispatch();

  const { messages, theme } = useReduxState();

  const handleDateRangeChange = ({ fromDate: from, toDate: to }) => {
    onDateRangeChange({ fromDate: from || '', toDate: to || '' });
  };

  return (
    <div className="header">
      <div className="header-info">
        <Button
          category="lighter"
          icon="arrow-left"
          isRounded={true}
          onClick={() =>
            editorDispatch({
              type: 'updateContext',
              update: { editorActiveView: 'edit' }
            })
          }
          size="header"
          tooltip={messages.commonGoBack}
        />

        <div className="title">{title}</div>
      </div>

      <div className="header-actions">
        <DateRangeSelector
          size="header"
          includeAllTimeOption={true}
          updateData={handleDateRangeChange}
        />
      </div>

      <style jsx>{`
        .header {
          align-items: center;
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          justify-content: space-between;
          width: 100%;
        }
        .header-info {
          align-items: center;
          display: flex;
          gap: 10px;
        }
        .title {
          color: ${theme.textColorLight};
          font-size: 1.5rem;
          font-weight: 700;
        }
        .subtitle {
          color: ${theme.textColorLighter};
          font-size: 1.3rem;
          font-weight: 600;
          margin-top: 1px;
        }
      `}</style>
    </div>
  );
};

export default memo(EditorVersionHistoryFilters);
